import { render } from "./AppointmentBatchCard.vue?vue&type=template&id=4417c5a6&scoped=true"
import script from "./AppointmentBatchCard.vue?vue&type=script&lang=js"
export * from "./AppointmentBatchCard.vue?vue&type=script&lang=js"

import "./AppointmentBatchCard.vue?vue&type=style&index=0&id=4417c5a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4417c5a6"]])

export default __exports__